import React, { useContext } from 'react';
import i18n from '@yandex-int/i18n';
import clx from 'classnames';
import { Context as AppStoreSnapshotContext } from '../../context/appStoreSnapshotContext';
import { AutoAppIcon, PlusIcon, SmartScreenAppIcon, TvAppIcon } from './AddNewAppIcons';
import { ErrorBoundary } from 'client/blocks/ErrorBoundary/ErrorBoundary';
import * as keyset from 'i18n/InstallableAppsIndex';
import { Channel } from 'client/model/skill';

import styles from './AddNewAppCard.module.scss';

export interface AddNewAppCardProps {
    onAppCreate: (channel: Channel) => void;
    channel: Channel;
}

interface ChannelContent {
    createLabel: string;
    icon: React.JSX.Element | null;
    shortDescription: string;
}

const t = i18n(keyset);

const mapChannelToContent: Record<Exclude<Channel, Channel.Thereminvox>, ChannelContent> = {
    [Channel.AutoApp]: {
        createLabel: t('create-auto-app'),
        icon: <AutoAppIcon />,
        shortDescription: 'Auto',
    },
    [Channel.TvApp]: {
        createLabel: t('create-tv-app'),
        icon: <TvAppIcon />,
        shortDescription: 'YaOs',
    },
    [Channel.SmartScreenApp]: {
        createLabel: t('create-smart-screen-app'),
        icon: <SmartScreenAppIcon />,
        shortDescription: 'Duo',
    },
    [Channel.AliceSkill]: {
        createLabel: t('create-alice-skill'),
        icon: null,
        shortDescription: 'AliceSkill',
    },
    [Channel.SmartHome]: {
        createLabel: t('create-smart-home'),
        icon: null,
        shortDescription: 'SmartHome',
    },
};

export const AddNewAppCard = ({ channel, onAppCreate }: AddNewAppCardProps) => {
    const { appStoreSnapshot } = useContext(AppStoreSnapshotContext);
    const disabled = appStoreSnapshot?.installableApps?.length >= appStoreSnapshot?.maxAppsPerUser;
    if (channel === Channel.Thereminvox) return null;
    const content = mapChannelToContent?.[channel];
    if (!content) return null;

    return (
        <ErrorBoundary>
            <div className={clx(styles.addNewAppCard__borderWrapper, disabled && styles.addNewAppCard_disabled)}>
                <div className={styles.addNewAppCard__container} onClick={() => onAppCreate(channel)}>
                    <div className={styles.addNewAppCard__contentContainer}>
                        <PlusIcon />
                        <h4 className={clx(styles.gradientText, styles.addNewAppCard__title)}>{content.createLabel}</h4>
                    </div>
                    <div className={styles.addNewAppCard__iconContainer}>
                        <div className={styles.gradientIcon__container}>{content.icon}</div>
                    </div>
                </div>
            </div>
        </ErrorBoundary>
    );
};
